import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatToolbarModule,
} from "@angular/material";
import { TranslateModule } from "@ngx-translate/core";
import { ErrorComponent } from "./components/error/error.component";
import { DefaultContainerComponent } from "./containers/default-container/default-container.component";
import { FocusFormularioInvalidoDirective } from "./directives/focus-formulario-invalido.directive";
import { ValidarCodigoIdespDirective } from "./directives/validar-codigo-idesp.directive";
import { ValidarDocumentoDirective } from "./directives/validar-documento.directive";
import { CapitalizePipe } from "./pipes/capitalize.pipe";

@NgModule({
  declarations: [
    CapitalizePipe,
    FocusFormularioInvalidoDirective,
    ValidarDocumentoDirective,
    ValidarCodigoIdespDirective,
    DefaultContainerComponent,
    ErrorComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonToggleModule,
    MatCardModule,
    MatIconModule,
  ],
  exports: [
    FlexLayoutModule,
    CapitalizePipe,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatInputModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatExpansionModule,
    ValidarDocumentoDirective,
    ValidarCodigoIdespDirective,
    FocusFormularioInvalidoDirective,
    DefaultContainerComponent,
  ],
})
export class SharedModule {}
